import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

export const Spinner: React.FC = () => <FontAwesomeIcon icon={['fas', 'spinner']} spin />;
